import React from "react";
import classNames from "classnames";

interface CaptureClicksProps {
    className?: string;
    children: React.ReactNode;
    /** When true, stops mouseDown from propagating. Default false. */
    stopMouseDown?: boolean;
    /** When true, stops pointerDown from propagating. Default false. */
    stopPointerDown?: boolean;
    /** When true, stops touchStart from propagating. Default false. */
    stopTouchStart?: boolean;
}
export const CaptureClicks: React.FC<CaptureClicksProps> = ({
    className,
    children,
    stopMouseDown = false,
    stopPointerDown = false,
    stopTouchStart = false,
}) => (
    <span
        className={classNames("d-inline-flex", className)}
        {...(stopMouseDown && {
            onMouseDown: (ev: React.MouseEvent) => ev.stopPropagation(),
        })}
        {...(stopPointerDown && {
            onPointerDown: (ev: React.PointerEvent) => ev.stopPropagation(),
        })}
        {...(stopTouchStart && {
            onTouchStart: (ev: React.TouchEvent) => ev.stopPropagation(),
        })}
        onClick={(ev) => ev.stopPropagation()}
    >
        {children}
    </span>
);
